
import './style.css';

import Translations from '../../data/Translations';
import SpecialsArray from '../../data/Specials';
import LazyImage from '../../components/LazyImage/LazyImage';
import SpecialsModal from './SpecialsModal';

const Specials = ({ currentLanguage }) => {
    return (
        <>
            <section id="specials" class="specials section-bg">
                <div class="container" data-aos="fade-up">

                    <div class="section-title">
                        <h2>{Translations.specials[currentLanguage]}</h2>
                        <p>{Translations.specialsTitle[currentLanguage]}</p>
                    </div>

                    <div class="row content">
                        <div class="col-lg-12">
                            <p>
                                {Translations.specialsDescription[currentLanguage]}
                            </p>
                        </div>
                    </div>

                    <div class="row" data-aos="fade-up" data-aos-delay="100">
                        {
                            SpecialsArray.map((item, index) => {
                                const id = `special-${index}`;

                                return (
                                    <>
                                        <div className="col-lg-4 col-md-6" key={index}>
                                            <div
                                                className="member"
                                                data-bs-toggle="modal"
                                                data-bs-target={`#${id}`}
                                            >
                                                <div className="pic">
                                                    <LazyImage
                                                        src={item.images[0]}
                                                        alt={item.name[currentLanguage]}
                                                    />
                                                </div>

                                                <div className="member-info">
                                                    <h4>{item.name[currentLanguage]}</h4>
                                                </div>
                                            </div>
                                        </div>

                                        <SpecialsModal
                                            special={item}
                                            currentLanguage={currentLanguage}
                                            id={id}
                                        />
                                    </>
                                );
                            })
                        }
                    </div>
                </div>
            </section>
        </>
    )
}

export default Specials;